import { createSlice } from "@reduxjs/toolkit";
import { STATUS_CODES } from "@src/config/constant";
import { toast } from "react-toastify";
import { APIResponse } from "../types/Common";
import { TravelService } from "@src/services/TravelService";

const Travel = createSlice({
    name: "travel",
    initialState: {
        travelLeadList: {},
        travelLeadListFilters: {},
        travelFormConfig: [],
        travelCommonConfig: {},
    },
    reducers: {
        travelLeadList: (state, action) => {
            state.travelLeadList = action.payload;
        },
        travelLeadListFilters: (state, action) => {
            state.travelLeadListFilters = action.payload;
        },
        travelFormConfig: (state, action) => {
            state.travelFormConfig = action.payload;
        },
        travelCommonConfig: (state, action) => {
            state.travelCommonConfig = action.payload;
        },
    },
});

export default Travel.reducer;

const {
    travelLeadList: setTravelLeadList,
    travelLeadListFilters: setTravelLeadListFilters,
    travelFormConfig: setTravelFormConfig,
    travelCommonConfig: setTravelCommonConfig,
} = Travel.actions;

export const travelLeadListFilters = (params: object) => async (dispatch: any) => {
    dispatch(setTravelLeadListFilters(params));
};

export const getTravelLeadList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        TravelService.travelLeadList(params as any).then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_CODES["success"]) {
                    resolve(response.data);
                    dispatch(setTravelLeadList(response.data));
                } else {
                    let errorMsg = (response && response.data && response.data.message) || "";
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data);
                }
            },
            (error: Error) => {
                reject(error);
            }
        );
    });
};

export const getTravelFormConfig = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        TravelService.getTravelFormConfig().then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_CODES["success"]) {
                    const formFields = response?.data?.data?.insuranceFormFields || response?.data?.data?.agencyAppFormField || [];
                    resolve(formFields);
                    dispatch(setTravelFormConfig(formFields));
                } else {
                    let errorMsg = (response && response.data && response.data.message) || "";
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data);
                }
            },
            (error: Error) => {
                reject(error);
            }
        );
    });
};

export const getTravelCommonConfig = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        TravelService.getTravelCommonConfig().then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_CODES["success"]) {
                    const configData = response?.data?.data || {};
                    dispatch(setTravelCommonConfig(configData));
                    resolve(configData);
                } else {
                    let errorMsg = (response && response.data && response.data.message) || "";
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data);
                }
            },
            (error: Error) => {
                reject(error);
            }
        );
    });
};

export const generateTravelQrCode = (params: object) => async () => {
    return new Promise((resolve, reject) => {
        TravelService.generateTravelQrCode(params as any).then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_CODES["success"]) {
                    if (response.data.message) toast.success(response.data.message);
                    resolve(response.data);
                } else {
                    let errorMsg = (response && response.data && response.data.message) || "";
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data);
                }
            },
            (error: Error) => {
                reject(error);
            }
        );
    });
};
